import { useContext, createContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export function useLanguage() {
    return useContext(LanguageContext);
}

export function LanguageProvider({children}) {
    const [language, setLanguage] = useState(() => {
        const localValue = localStorage.getItem('lang');
        return localValue || 'eng';
    });

    function switchLanguage(lang) {
        setLanguage(lang);
    }

    function getTranslation(vn, en) {
        return language === "vie" ? vn : en;
    }

    function getLanguage() {
        return language;
    }

    useEffect(() => {
        localStorage.setItem('lang', language);
    }, [language]);

    const value = {
        getTranslation,
        switchLanguage,
        getLanguage
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    )
}